import { Tooltip, Typography } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import { muiTheme } from 'mui-theme'

type TestSuiteCompositionInputFieldHelperTextProps =
  | {
      errorMessage: string
      helperText?: never
      infoTooltipText?: never
    }
  | {
      errorMessage?: never
      helperText: string
      infoTooltipText?: string
    }

export const TestSuiteCompositionInputFieldHelperText: React.FC<
  TestSuiteCompositionInputFieldHelperTextProps
> = ({ errorMessage, helperText, infoTooltipText }) => {
  if (errorMessage) {
    return (
      <Typography color="error" variant="inherit">
        {errorMessage}
      </Typography>
    )
  }

  return (
    <>
      {helperText}
      {infoTooltipText && (
        <Tooltip arrow placement="right" title={infoTooltipText}>
          <Icon
            css={{
              color: muiTheme.palette.grey['600'],
              marginLeft: muiTheme.spacing(0.5)
            }}
            icon="solidCircleInfo"
          />
        </Tooltip>
      )}
    </>
  )
}
